import { computed } from "vue";
import { watchOnce, useVirtualList } from "@vueuse/core";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
const wrapper = "_wrapper_kngqx_1";
const style0 = {
  wrapper
};
const __default__ = {
  name: "ListItemsContainer"
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    virtualizedList: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:list", "mounted:virtualized-list"],
  setup(__props, { emit }) {
    const props = __props;
    const listItems = computed(() => props.items);
    function useListItems() {
      let list2;
      let wrapperProps2;
      let containerProps2;
      if (props.virtualizedList) {
        ({ list: list2, wrapperProps: wrapperProps2, containerProps: containerProps2 } = useVirtualList(listItems, {
          itemHeight: 40,
          overscan: 30
        }));
      }
      const computedItems = computed(() => {
        if (props.virtualizedList) {
          return [...list2.value].map((item) => ({
            ...item == null ? void 0 : item.data,
            index: item == null ? void 0 : item.index
          }));
        }
        return listItems.value;
      });
      return {
        list: computedItems,
        containerProps: containerProps2,
        wrapperProps: wrapperProps2
      };
    }
    const { list, containerProps, wrapperProps } = useListItems();
    watchOnce(list, () => {
      if (props.virtualizedList) {
        emit("mounted:virtualized-list");
      }
    });
    return { __sfc: true, props, emit, listItems, useListItems, list, containerProps, wrapperProps };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return !_vm.virtualizedList ? _c("ul", [_vm._t("before"), _vm._t("default", null, { "list": _setup.list }), _vm._t("after")], 2) : _c("div", { ref: _setup.containerProps.ref, style: _setup.containerProps.style, on: { "scroll": _setup.containerProps.onScroll } }, [_vm._t("before"), _c("ul", { class: _vm.$style.wrapper, style: _setup.wrapperProps.style }, [_vm._t("default", null, { "list": _setup.list })], 2), _vm._t("after")], 2);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const ListItemsContainer = __component__.exports;
export {
  ListItemsContainer as default
};
